export const prefixSvgIds = (
  container: HTMLElement | null,
  prefix?: string,
) => {
  if (!container) return;

  const svgs = Array.from(container.querySelectorAll('svg')) as SVGElement[];

  if (svgs.length === 0) return;

  svgs.forEach(svgEl => {
    const el = svgEl as unknown as HTMLElement;

    // avoid double-processing per svg
    if (el.dataset?.prefixed === 'true') return;

    const rand = Math.random().toString(36).slice(2, 8);
    const shortPrefix = `${prefix ?? 'svg'}-${rand}`;

    const elementsWithId = Array.from(
      svgEl.querySelectorAll('[id]'),
    ) as Element[];

    if (elementsWithId.length === 0) {
      el.dataset.prefixed = 'true';

      return;
    }

    const idMap = new Map<string, string>();

    elementsWithId.forEach(element => {
      const oldId = element.getAttribute('id');

      if (!oldId) return;

      const newId = `${shortPrefix}-${oldId}`;

      idMap.set(oldId, newId);
      element.setAttribute('id', newId);
    });

    const allElements = Array.from(svgEl.querySelectorAll('*')) as Element[];

    allElements.forEach(element => {
      for (const attributeName of element.getAttributeNames()) {
        const value = element.getAttribute(attributeName);

        if (!value) continue;

        let newValue = value;

        newValue = newValue.replace(/url\(#([^)]+)\)/g, (match, capturedId) => {
          return idMap.has(capturedId)
            ? `url(#${idMap.get(capturedId)})`
            : `url(#${capturedId})`;
        });

        newValue = newValue.replace(
          /(^|[^A-Za-z0-9_-])#([A-Za-z0-9_\-:]+)/g,
          (match, leadingChar, capturedId) => {
            return idMap.has(capturedId)
              ? `${leadingChar}#${idMap.get(capturedId)}`
              : match;
          },
        );

        if (newValue !== value) element.setAttribute(attributeName, newValue);
      }
    });

    el.dataset.prefixed = 'true';
  });
};

export default prefixSvgIds;
